import type { XEntity } from './api';
import { API_BASE_URL, IS_DEV } from './config/setting';
import { dataFillCurrInfo, getToken } from './utils/lzd-util';

/**
 * 错误类型枚举
 */
export enum ErrorType {
  /** 脚本错误 */
  SCRIPT_ERROR = 'script_error',
  PROMISE_ERROR = 'promise_error'
}

/**
 * 错误信息接口
 */
export interface ErrorInfo extends XEntity {
  userid?: string;
  username?: string;
  ip?: string;
  type: ErrorType;
  message: string;
  stack?: string;
  url?: string;
  rowNum?: number;
  cellNum?: number;
  status?: string;
  userAgent: string;
  page: string;
  device: 'desktop' | 'mobile' | 'tablet';
  createdAt: string | number;
}

/**
 * 获取设备类型
 */
const getDeviceType = (): 'desktop' | 'mobile' | 'tablet' => {
  const ua = navigator.userAgent;
  if (/Mobile|Android/i.test(ua)) return 'mobile';
  if (/Tablet|iPad/i.test(ua)) return 'tablet';
  return 'desktop';
};

let url: string | null = null;
/** 上报函数 */
function reportError(data: ErrorInfo) {
  const token = getToken();
  if (!token) {
    return;
  }
  dataFillCurrInfo(data);

  // url = API_BASE_URL + '/bsl/system/page/error/record/insert'
  if (!url) {
    url =
      API_BASE_URL +
      atob(
        atob('TDJKemJDOXplWE4wWlcwdmNHRm5aUzlsY25KdmNpOXlaV052Y21RdmFXNXpaWEow')
      );
  }
  fetch(url, {
    method: 'POST',
    headers: {
      Authorization: token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).catch((_) => {});
}

/**
 * 全局异常捕获
 */
export function useGlobalExceptionHandler() {
  // 开发环境跳过错误全局错误收集
  if (IS_DEV) {
    return;
  }
  const _onerror = globalThis.onerror;

  // 捕获脚本运行时错误（核心！）
  globalThis.onerror = (message, source, lineno, colno, error) => {
    _onerror && _onerror(message, source, lineno, colno, error);

    // 上报
    const data: ErrorInfo = {
      type: ErrorType.SCRIPT_ERROR,
      message: String(message),
      stack: error?.stack,
      url: source,
      rowNum: lineno,
      cellNum: colno,
      userAgent: navigator.userAgent,
      page: location.pathname,
      device: getDeviceType(),
      createdAt: Date.now()
    };

    reportError(data);
  };

  // 捕获未处理的 Promise 错误
  globalThis.addEventListener(
    'unhandledrejection',
    (evt: PromiseRejectionEvent) => {
      // 上报
      const data: ErrorInfo = {
        type: ErrorType.PROMISE_ERROR,
        message: evt.reason?.message || String(evt.reason),
        stack: evt.reason?.stack,
        userAgent: navigator.userAgent,
        page: location.pathname,
        device: getDeviceType(),
        createdAt: Date.now()
      };

      reportError(data);
    }
  );
}
